import { IGetProjetoByIdUseCase } from "../../../presentation/useCases/read/get_projeto_by_id_use_case";
import { GetProjetoByIdRequestModel, GetProjetoByIdResponseModel } from "../../models/projeto_model";
import { ProjetoLista } from "../../models/projetos_Lista";
import { IProjetosRepository } from "../../repositories/projetos_repository";


export class GetProjetoByIdUseCase implements IGetProjetoByIdUseCase {
  constructor(private readonly repository: IProjetosRepository) {}

  async getProjetoById(IdProjeto: number): Promise<ProjetoLista> {
    return await this.repository.getProjetoById(IdProjeto);
  }
}
